import {
  register,
  signup
} from "./chunk-XZRA6EPR.mjs";

// src/hooks/wbk/auth/register.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useSignup = () => {
  return useMutation({
    mutationFn: signup
  });
};
var useRegister = ({ lang }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: register,
    onSuccess: (user) => {
      queryClient.setQueryData(["user", { lang }], user);
    }
  });
};

export {
  useSignup,
  useRegister
};
//# sourceMappingURL=chunk-X4TNUDNX.mjs.map